// src/firebase.js - Dynamic Firebase Configuration
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

// Environment-based configuration
const getFirebaseConfig = () => {
  const env = process.env.REACT_APP_FIREBASE_ENV || 'prod';
  if (env === 'dev') {
    return {
      apiKey: "AIzaSyDgEJu60xm2-f3y6L_CCuUxNNXFxASGgys",
      authDomain: "image-drop-aee6c.firebaseapp.com",
      projectId: "image-drop-aee6c",
      storageBucket: "image-drop-aee6c.appspot.com",
      messagingSenderId: "717299503411",
      appId: "1:717299503411:web:9d6e173dac7ce735c0ae46",
      measurementId: "G-PFNP7SX51Q"
    };
  } else {
    // Production configuration
    return {
      apiKey: "AIzaSyBNuJceV6SZR4lsErlhV8qmBpUoQroscso",
      authDomain: "json-storage-bed47.firebaseapp.com",
      databaseURL: "https://json-storage-bed47-default-rtdb.firebaseio.com",
      projectId: "json-storage-bed47",
      storageBucket: "json-storage-bed47.appspot.com",
      messagingSenderId: "451919785006",
      appId: "1:451919785006:web:8623493929c1eb58fb83bf",
    };
  }
};

const firebaseConfig = getFirebaseConfig();
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider("microsoft.com");
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { auth, db, storage, provider, microsoftProvider, analytics, database };
